import type {
  EmitsOptions,
  ExtractPropTypes,
  ExtractPublicPropTypes,
  PropType,
} from "vue";
import type { WithOnEmits } from "../../../utils";
import type Radio from "./radio.vue";

export const RadioProps = {
  modelValue: [String, Number, Boolean],
  size: {
    type: String as PropType<"large" | "default" | "small" | "">,
    default: "",
  },
  disabled: Boolean,
  textColor: {
    type: String,
    default: "",
  },
  fill: String,
  validateEvent: Boolean,
  type: {
    type: String as PropType<"button" | "">,
    default: "",
  },
  data: {
    type: [String, Array],
    default: () => [],
  },
  dataCallback: {
    type: Function,
  },
  optLabel: {
    type: String,
    default: "label",
  },
  optValue: {
    type: String,
    default: "value",
  },
};

export const RadioEmits = {
  "update:modelValue": (value: any) => value,
  change: (value: any) => value,
} satisfies EmitsOptions;

export const excludeRadioKeys = [
  "type",
  "data",
  "dataCallback",
  "optLabel",
  "optValue",
  "modelValue",
];

export type RadioPropsType = ExtractPropTypes<typeof RadioProps>;

export type RadioPublicPropsType = ExtractPublicPropTypes<typeof RadioProps> &
  WithOnEmits<typeof RadioEmits>;

export type RadioEmitsType = typeof RadioEmits;

export type RadioInstance = InstanceType<typeof Radio>;
